import React, { createContext, useContext, useState, useEffect } from "react";

const MobileContext = createContext();

function isMobileNavigator() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const mobileUA = (
    navigator.userAgentData?.mobile === true ||
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/i.test(navigator.userAgent)
  );
  const coarsePointer = window.matchMedia?.('(pointer: coarse)').matches ?? false;
  const noHover = window.matchMedia?.('(hover: none)').matches ?? false;
  const hasTouchPoints = (navigator.maxTouchPoints || 0) > 0;

  return mobileUA || ((coarsePointer || noHover) && hasTouchPoints);
}

export function MobileProvider({ children }) {
  const [isMobile, setIsMobile] = useState(isMobileNavigator());

  useEffect(() => {
    const handleResize = () => setIsMobile(isMobileNavigator());
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    const coarse = window.matchMedia?.('(pointer: coarse)');
    const hover = window.matchMedia?.('(hover: none)');
    coarse?.addEventListener?.('change', handleResize);
    hover?.addEventListener?.('change', handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
      coarse?.removeEventListener?.('change', handleResize);
      hover?.removeEventListener?.('change', handleResize);
    };
  }, []);

  return (
    <MobileContext.Provider value={{ isMobile }}>
      {children}
    </MobileContext.Provider>
  );
}

export function useMobile() {
  return useContext(MobileContext);
}
